export const koKR_etc = {
   'title.codeChecker': 'UKW 활성코드 조회기',
}